import React, { useEffect, useState } from 'react';

import { DATA_KEYS_MOTOR_SKILLS } from 'constants/index';
import { handleMotorSkills } from 'utils/helper';

const spanMap = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  6: 'col-span-6',
  12: 'col-span-12',
};

const AthleticAbilityIcon_5 = require('assets/resources/AthleticAbilityIcon_5.svg').default;

const generateItem = (dataKeyMotorSkill, data, isChild = false) => {
  return dataKeyMotorSkill.map((item, index) => (
    <div
      key={`athletic-ability-${index}`}
      className={`flex flex-col gap-2 bg-white-720 rounded ${isChild ? '' : 'p-2'} ${spanMap[Math.ceil(12 / dataKeyMotorSkill.length)]}`}
    >
      {item?.title && <h3 className="text-sm font-bold text-black-102 text-center">{item?.title}</h3>}
      <div className={'flex justify-center gap-2 '}>{handleMotorSkills(data?.[item?.key])}</div>
      {item?.children && <div className="grid grid-cols-12 gap-2">{generateItem(item?.children, data, true)}</div>}
    </div>
  ));
};

const AthleticAbility = (props) => {
  const { data } = props;
  const [dataMotorSkills, setDataMotorSkills] = useState({});

  useEffect(() => {
    if (data?.analysis_results?.motor_skills) {
      const dataMotorSkills = {};
      for (const key in data?.analysis_results?.motor_skills) {
        if (typeof data?.analysis_results?.motor_skills[key] === 'object') {
          dataMotorSkills[key] = data?.analysis_results?.motor_skills[key].result;
        } else {
          dataMotorSkills[key] = data?.analysis_results?.motor_skills[key];
        }
        setDataMotorSkills(dataMotorSkills);
      }
    }
  }, [data]);

  return (
    <>
      <div className="grid grid-cols-12 gap-2">
        {DATA_KEYS_MOTOR_SKILLS?.map((dataKeyMotorSkill, index) => (
          <React.Fragment key={`athletic-ability-${index}`}>
            {dataKeyMotorSkill?.map((item) => generateItem(item, dataMotorSkills))}
            {index < DATA_KEYS_MOTOR_SKILLS?.length - 1 && (
              <div className="col-span-12 flex justify-center py-2">
                <img src={AthleticAbilityIcon_5} alt="athletic-ability-icon-5" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default AthleticAbility;
